var __create = Object.create;
var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties,
  __getOwnPropDesc = Object.getOwnPropertyDescriptor,
  __getOwnPropDescs = Object.getOwnPropertyDescriptors,
  __getOwnPropNames = Object.getOwnPropertyNames,
  __getOwnPropSymbols = Object.getOwnPropertySymbols,
  __getProtoOf = Object.getPrototypeOf,
  __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
var __commonJS = (cb, mod) => function () {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
    get: () => from[key],
    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
  });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: !0
}) : target, mod));
var require_isArray = __commonJS({
  "../../../node_modules/lodash/isArray.js"(exports, module) {
    var isArray = Array.isArray;
    module.exports = isArray;
  }
});
var require_freeGlobal = __commonJS({
  "../../../node_modules/lodash/_freeGlobal.js"(exports, module) {
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});
var require_root = __commonJS({
  "../../../node_modules/lodash/_root.js"(exports, module) {
    var freeGlobal = require_freeGlobal(),
      freeSelf = typeof self == "object" && self && self.Object === Object && self,
      root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});
var require_Symbol = __commonJS({
  "../../../node_modules/lodash/_Symbol.js"(exports, module) {
    var root = require_root(),
      Symbol = root.Symbol;
    module.exports = Symbol;
  }
});
var require_getRawTag = __commonJS({
  "../../../node_modules/lodash/_getRawTag.js"(exports, module) {
    var Symbol = require_Symbol(),
      objectProto = Object.prototype,
      hasOwnProperty = objectProto.hasOwnProperty,
      nativeObjectToString = objectProto.toString,
      symToStringTag = Symbol ? Symbol.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = !0;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      return unmasked && (isOwn ? value[symToStringTag] = tag : delete value[symToStringTag]), result;
    }
    module.exports = getRawTag;
  }
});
var require_objectToString = __commonJS({
  "../../../node_modules/lodash/_objectToString.js"(exports, module) {
    var objectProto = Object.prototype,
      nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;
  }
});
var require_baseGetTag = __commonJS({
  "../../../node_modules/lodash/_baseGetTag.js"(exports, module) {
    var Symbol = require_Symbol(),
      getRawTag = require_getRawTag(),
      objectToString = require_objectToString(),
      nullTag = "[object Null]",
      undefinedTag = "[object Undefined]",
      symToStringTag = Symbol ? Symbol.toStringTag : void 0;
    function baseGetTag(value) {
      return value == null ? value === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;
  }
});
var require_isObjectLike = __commonJS({
  "../../../node_modules/lodash/isObjectLike.js"(exports, module) {
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});
var require_isSymbol = __commonJS({
  "../../../node_modules/lodash/isSymbol.js"(exports, module) {
    var baseGetTag = require_baseGetTag(),
      isObjectLike = require_isObjectLike(),
      symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module.exports = isSymbol;
  }
});
var require_isKey = __commonJS({
  "../../../node_modules/lodash/_isKey.js"(exports, module) {
    var isArray = require_isArray(),
      isSymbol = require_isSymbol(),
      reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/;
    function isKey(value, object) {
      if (isArray(value)) return !1;
      var type = typeof value;
      return type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value) ? !0 : reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    module.exports = isKey;
  }
});
var require_isObject = __commonJS({
  "../../../node_modules/lodash/isObject.js"(exports, module) {
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module.exports = isObject;
  }
});
var require_isFunction = __commonJS({
  "../../../node_modules/lodash/isFunction.js"(exports, module) {
    var baseGetTag = require_baseGetTag(),
      isObject = require_isObject(),
      asyncTag = "[object AsyncFunction]",
      funcTag = "[object Function]",
      genTag = "[object GeneratorFunction]",
      proxyTag = "[object Proxy]";
    function isFunction(value) {
      if (!isObject(value)) return !1;
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module.exports = isFunction;
  }
});
var require_coreJsData = __commonJS({
  "../../../node_modules/lodash/_coreJsData.js"(exports, module) {
    var root = require_root(),
      coreJsData = root["__core-js_shared__"];
    module.exports = coreJsData;
  }
});
var require_isMasked = __commonJS({
  "../../../node_modules/lodash/_isMasked.js"(exports, module) {
    var coreJsData = require_coreJsData(),
      maskSrcKey = function () {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module.exports = isMasked;
  }
});
var require_toSource = __commonJS({
  "../../../node_modules/lodash/_toSource.js"(exports, module) {
    var funcProto = Function.prototype,
      funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return func + "";
        } catch (e) {}
      }
      return "";
    }
    module.exports = toSource;
  }
});
var require_baseIsNative = __commonJS({
  "../../../node_modules/lodash/_baseIsNative.js"(exports, module) {
    var isFunction = require_isFunction(),
      isMasked = require_isMasked(),
      isObject = require_isObject(),
      toSource = require_toSource(),
      reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reIsHostCtor = /^\[object .+?Constructor\]$/,
      funcProto = Function.prototype,
      objectProto = Object.prototype,
      funcToString = funcProto.toString,
      hasOwnProperty = objectProto.hasOwnProperty,
      reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) return !1;
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module.exports = baseIsNative;
  }
});
var require_getValue = __commonJS({
  "../../../node_modules/lodash/_getValue.js"(exports, module) {
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    module.exports = getValue;
  }
});
var require_getNative = __commonJS({
  "../../../node_modules/lodash/_getNative.js"(exports, module) {
    var baseIsNative = require_baseIsNative(),
      getValue = require_getValue();
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    module.exports = getNative;
  }
});
var require_nativeCreate = __commonJS({
  "../../../node_modules/lodash/_nativeCreate.js"(exports, module) {
    var getNative = require_getNative(),
      nativeCreate = getNative(Object, "create");
    module.exports = nativeCreate;
  }
});
var require_hashClear = __commonJS({
  "../../../node_modules/lodash/_hashClear.js"(exports, module) {
    var nativeCreate = require_nativeCreate();
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
    }
    module.exports = hashClear;
  }
});
var require_hashDelete = __commonJS({
  "../../../node_modules/lodash/_hashDelete.js"(exports, module) {
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      return this.size -= result ? 1 : 0, result;
    }
    module.exports = hashDelete;
  }
});
var require_hashGet = __commonJS({
  "../../../node_modules/lodash/_hashGet.js"(exports, module) {
    var nativeCreate = require_nativeCreate(),
      HASH_UNDEFINED = "__lodash_hash_undefined__",
      objectProto = Object.prototype,
      hasOwnProperty = objectProto.hasOwnProperty;
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    module.exports = hashGet;
  }
});
var require_hashHas = __commonJS({
  "../../../node_modules/lodash/_hashHas.js"(exports, module) {
    var nativeCreate = require_nativeCreate(),
      objectProto = Object.prototype,
      hasOwnProperty = objectProto.hasOwnProperty;
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    module.exports = hashHas;
  }
});
var require_hashSet = __commonJS({
  "../../../node_modules/lodash/_hashSet.js"(exports, module) {
    var nativeCreate = require_nativeCreate(),
      HASH_UNDEFINED = "__lodash_hash_undefined__";
    function hashSet(key, value) {
      var data = this.__data__;
      return this.size += this.has(key) ? 0 : 1, data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value, this;
    }
    module.exports = hashSet;
  }
});
var require_Hash = __commonJS({
  "../../../node_modules/lodash/_Hash.js"(exports, module) {
    var hashClear = require_hashClear(),
      hashDelete = require_hashDelete(),
      hashGet = require_hashGet(),
      hashHas = require_hashHas(),
      hashSet = require_hashSet();
    function Hash(entries) {
      var index2 = -1,
        length = entries == null ? 0 : entries.length;
      for (this.clear(); ++index2 < length;) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype.delete = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module.exports = Hash;
  }
});
var require_listCacheClear = __commonJS({
  "../../../node_modules/lodash/_listCacheClear.js"(exports, module) {
    function listCacheClear() {
      this.__data__ = [], this.size = 0;
    }
    module.exports = listCacheClear;
  }
});
var require_eq = __commonJS({
  "../../../node_modules/lodash/eq.js"(exports, module) {
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module.exports = eq;
  }
});
var require_assocIndexOf = __commonJS({
  "../../../node_modules/lodash/_assocIndexOf.js"(exports, module) {
    var eq = require_eq();
    function assocIndexOf(array, key) {
      for (var length = array.length; length--;) if (eq(array[length][0], key)) return length;
      return -1;
    }
    module.exports = assocIndexOf;
  }
});
var require_listCacheDelete = __commonJS({
  "../../../node_modules/lodash/_listCacheDelete.js"(exports, module) {
    var assocIndexOf = require_assocIndexOf(),
      arrayProto = Array.prototype,
      splice = arrayProto.splice;
    function listCacheDelete(key) {
      var data = this.__data__,
        index2 = assocIndexOf(data, key);
      if (index2 < 0) return !1;
      var lastIndex = data.length - 1;
      return index2 == lastIndex ? data.pop() : splice.call(data, index2, 1), --this.size, !0;
    }
    module.exports = listCacheDelete;
  }
});
var require_listCacheGet = __commonJS({
  "../../../node_modules/lodash/_listCacheGet.js"(exports, module) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheGet(key) {
      var data = this.__data__,
        index2 = assocIndexOf(data, key);
      return index2 < 0 ? void 0 : data[index2][1];
    }
    module.exports = listCacheGet;
  }
});
var require_listCacheHas = __commonJS({
  "../../../node_modules/lodash/_listCacheHas.js"(exports, module) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    module.exports = listCacheHas;
  }
});
var require_listCacheSet = __commonJS({
  "../../../node_modules/lodash/_listCacheSet.js"(exports, module) {
    var assocIndexOf = require_assocIndexOf();
    function listCacheSet(key, value) {
      var data = this.__data__,
        index2 = assocIndexOf(data, key);
      return index2 < 0 ? (++this.size, data.push([key, value])) : data[index2][1] = value, this;
    }
    module.exports = listCacheSet;
  }
});
var require_ListCache = __commonJS({
  "../../../node_modules/lodash/_ListCache.js"(exports, module) {
    var listCacheClear = require_listCacheClear(),
      listCacheDelete = require_listCacheDelete(),
      listCacheGet = require_listCacheGet(),
      listCacheHas = require_listCacheHas(),
      listCacheSet = require_listCacheSet();
    function ListCache(entries) {
      var index2 = -1,
        length = entries == null ? 0 : entries.length;
      for (this.clear(); ++index2 < length;) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype.delete = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module.exports = ListCache;
  }
});
var require_Map = __commonJS({
  "../../../node_modules/lodash/_Map.js"(exports, module) {
    var getNative = require_getNative(),
      root = require_root(),
      Map = getNative(root, "Map");
    module.exports = Map;
  }
});
var require_mapCacheClear = __commonJS({
  "../../../node_modules/lodash/_mapCacheClear.js"(exports, module) {
    var Hash = require_Hash(),
      ListCache = require_ListCache(),
      Map = require_Map();
    function mapCacheClear() {
      this.size = 0, this.__data__ = {
        hash: new Hash(),
        map: new (Map || ListCache)(),
        string: new Hash()
      };
    }
    module.exports = mapCacheClear;
  }
});
var require_isKeyable = __commonJS({
  "../../../node_modules/lodash/_isKeyable.js"(exports, module) {
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    module.exports = isKeyable;
  }
});
var require_getMapData = __commonJS({
  "../../../node_modules/lodash/_getMapData.js"(exports, module) {
    var isKeyable = require_isKeyable();
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    module.exports = getMapData;
  }
});
var require_mapCacheDelete = __commonJS({
  "../../../node_modules/lodash/_mapCacheDelete.js"(exports, module) {
    var getMapData = require_getMapData();
    function mapCacheDelete(key) {
      var result = getMapData(this, key).delete(key);
      return this.size -= result ? 1 : 0, result;
    }
    module.exports = mapCacheDelete;
  }
});
var require_mapCacheGet = __commonJS({
  "../../../node_modules/lodash/_mapCacheGet.js"(exports, module) {
    var getMapData = require_getMapData();
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    module.exports = mapCacheGet;
  }
});
var require_mapCacheHas = __commonJS({
  "../../../node_modules/lodash/_mapCacheHas.js"(exports, module) {
    var getMapData = require_getMapData();
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    module.exports = mapCacheHas;
  }
});
var require_mapCacheSet = __commonJS({
  "../../../node_modules/lodash/_mapCacheSet.js"(exports, module) {
    var getMapData = require_getMapData();
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
        size = data.size;
      return data.set(key, value), this.size += data.size == size ? 0 : 1, this;
    }
    module.exports = mapCacheSet;
  }
});
var require_MapCache = __commonJS({
  "../../../node_modules/lodash/_MapCache.js"(exports, module) {
    var mapCacheClear = require_mapCacheClear(),
      mapCacheDelete = require_mapCacheDelete(),
      mapCacheGet = require_mapCacheGet(),
      mapCacheHas = require_mapCacheHas(),
      mapCacheSet = require_mapCacheSet();
    function MapCache(entries) {
      var index2 = -1,
        length = entries == null ? 0 : entries.length;
      for (this.clear(); ++index2 < length;) {
        var entry = entries[index2];
        this.set(entry[0], entry[1]);
      }
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype.delete = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module.exports = MapCache;
  }
});
var require_memoize = __commonJS({
  "../../../node_modules/lodash/memoize.js"(exports, module) {
    var MapCache = require_MapCache(),
      FUNC_ERROR_TEXT = "Expected a function";
    function memoize(func, resolver) {
      if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
      var memoized = function () {
        var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        return memoized.cache = cache.set(key, result) || cache, result;
      };
      return memoized.cache = new (memoize.Cache || MapCache)(), memoized;
    }
    memoize.Cache = MapCache;
    module.exports = memoize;
  }
});
var require_memoizeCapped = __commonJS({
  "../../../node_modules/lodash/_memoizeCapped.js"(exports, module) {
    var memoize = require_memoize(),
      MAX_MEMOIZE_SIZE = 500;
    function memoizeCapped(func) {
      var result = memoize(func, function (key) {
          return cache.size === MAX_MEMOIZE_SIZE && cache.clear(), key;
        }),
        cache = result.cache;
      return result;
    }
    module.exports = memoizeCapped;
  }
});
var require_stringToPath = __commonJS({
  "../../../node_modules/lodash/_stringToPath.js"(exports, module) {
    var memoizeCapped = require_memoizeCapped(),
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      reEscapeChar = /\\(\\)?/g,
      stringToPath = memoizeCapped(function (string) {
        var result = [];
        return string.charCodeAt(0) === 46 && result.push(""), string.replace(rePropName, function (match, number, quote, subString) {
          result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
        }), result;
      });
    module.exports = stringToPath;
  }
});
var require_arrayMap = __commonJS({
  "../../../node_modules/lodash/_arrayMap.js"(exports, module) {
    function arrayMap(array, iteratee) {
      for (var index2 = -1, length = array == null ? 0 : array.length, result = Array(length); ++index2 < length;) result[index2] = iteratee(array[index2], index2, array);
      return result;
    }
    module.exports = arrayMap;
  }
});
var require_baseToString = __commonJS({
  "../../../node_modules/lodash/_baseToString.js"(exports, module) {
    var Symbol = require_Symbol(),
      arrayMap = require_arrayMap(),
      isArray = require_isArray(),
      isSymbol = require_isSymbol(),
      INFINITY = 1 / 0,
      symbolProto = Symbol ? Symbol.prototype : void 0,
      symbolToString = symbolProto ? symbolProto.toString : void 0;
    function baseToString(value) {
      if (typeof value == "string") return value;
      if (isArray(value)) return arrayMap(value, baseToString) + "";
      if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module.exports = baseToString;
  }
});
var require_toString = __commonJS({
  "../../../node_modules/lodash/toString.js"(exports, module) {
    var baseToString = require_baseToString();
    function toString(value) {
      return value == null ? "" : baseToString(value);
    }
    module.exports = toString;
  }
});
var require_castPath = __commonJS({
  "../../../node_modules/lodash/_castPath.js"(exports, module) {
    var isArray = require_isArray(),
      isKey = require_isKey(),
      stringToPath = require_stringToPath(),
      toString = require_toString();
    function castPath(value, object) {
      return isArray(value) ? value : isKey(value, object) ? [value] : stringToPath(toString(value));
    }
    module.exports = castPath;
  }
});
var require_toKey = __commonJS({
  "../../../node_modules/lodash/_toKey.js"(exports, module) {
    var isSymbol = require_isSymbol(),
      INFINITY = 1 / 0;
    function toKey(value) {
      if (typeof value == "string" || isSymbol(value)) return value;
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module.exports = toKey;
  }
});
var require_baseGet = __commonJS({
  "../../../node_modules/lodash/_baseGet.js"(exports, module) {
    var castPath = require_castPath(),
      toKey = require_toKey();
    function baseGet(object, path) {
      path = castPath(path, object);
      for (var index2 = 0, length = path.length; object != null && index2 < length;) object = object[toKey(path[index2++])];
      return index2 && index2 == length ? object : void 0;
    }
    module.exports = baseGet;
  }
});
var require_defineProperty = __commonJS({
  "../../../node_modules/lodash/_defineProperty.js"(exports, module) {
    var getNative = require_getNative(),
      defineProperty = function () {
        try {
          var func = getNative(Object, "defineProperty");
          return func({}, "", {}), func;
        } catch (e) {}
      }();
    module.exports = defineProperty;
  }
});
var require_baseAssignValue = __commonJS({
  "../../../node_modules/lodash/_baseAssignValue.js"(exports, module) {
    var defineProperty = require_defineProperty();
    function baseAssignValue(object, key, value) {
      key == "__proto__" && defineProperty ? defineProperty(object, key, {
        configurable: !0,
        enumerable: !0,
        value,
        writable: !0
      }) : object[key] = value;
    }
    module.exports = baseAssignValue;
  }
});
var require_assignValue = __commonJS({
  "../../../node_modules/lodash/_assignValue.js"(exports, module) {
    var baseAssignValue = require_baseAssignValue(),
      eq = require_eq(),
      objectProto = Object.prototype,
      hasOwnProperty = objectProto.hasOwnProperty;
    function assignValue(object, key, value) {
      var objValue = object[key];
      (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) && baseAssignValue(object, key, value);
    }
    module.exports = assignValue;
  }
});
var require_isIndex = __commonJS({
  "../../../node_modules/lodash/_isIndex.js"(exports, module) {
    var MAX_SAFE_INTEGER = 9007199254740991,
      reIsUint = /^(?:0|[1-9]\d*)$/;
    function isIndex(value, length) {
      var type = typeof value;
      return length = length == null ? MAX_SAFE_INTEGER : length, !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    module.exports = isIndex;
  }
});
var require_baseSet = __commonJS({
  "../../../node_modules/lodash/_baseSet.js"(exports, module) {
    var assignValue = require_assignValue(),
      castPath = require_castPath(),
      isIndex = require_isIndex(),
      isObject = require_isObject(),
      toKey = require_toKey();
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) return object;
      path = castPath(path, object);
      for (var index2 = -1, length = path.length, lastIndex = length - 1, nested = object; nested != null && ++index2 < length;) {
        var key = toKey(path[index2]),
          newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index2 != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : void 0, newValue === void 0 && (newValue = isObject(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {});
        }
        assignValue(nested, key, newValue), nested = nested[key];
      }
      return object;
    }
    module.exports = baseSet;
  }
});
var require_basePickBy = __commonJS({
  "../../../node_modules/lodash/_basePickBy.js"(exports, module) {
    var baseGet = require_baseGet(),
      baseSet = require_baseSet(),
      castPath = require_castPath();
    function basePickBy(object, paths, predicate) {
      for (var index2 = -1, length = paths.length, result = {}; ++index2 < length;) {
        var path = paths[index2],
          value = baseGet(object, path);
        predicate(value, path) && baseSet(result, castPath(path, object), value);
      }
      return result;
    }
    module.exports = basePickBy;
  }
});
var require_baseHasIn = __commonJS({
  "../../../node_modules/lodash/_baseHasIn.js"(exports, module) {
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }
    module.exports = baseHasIn;
  }
});
var require_baseIsArguments = __commonJS({
  "../../../node_modules/lodash/_baseIsArguments.js"(exports, module) {
    var baseGetTag = require_baseGetTag(),
      isObjectLike = require_isObjectLike(),
      argsTag = "[object Arguments]";
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module.exports = baseIsArguments;
  }
});
var require_isArguments = __commonJS({
  "../../../node_modules/lodash/isArguments.js"(exports, module) {
    var baseIsArguments = require_baseIsArguments(),
      isObjectLike = require_isObjectLike(),
      objectProto = Object.prototype,
      hasOwnProperty = objectProto.hasOwnProperty,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      isArguments = baseIsArguments(function () {
        return arguments;
      }()) ? baseIsArguments : function (value) {
        return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
    module.exports = isArguments;
  }
});
var require_isLength = __commonJS({
  "../../../node_modules/lodash/isLength.js"(exports, module) {
    var MAX_SAFE_INTEGER = 9007199254740991;
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module.exports = isLength;
  }
});
var require_hasPath = __commonJS({
  "../../../node_modules/lodash/_hasPath.js"(exports, module) {
    var castPath = require_castPath(),
      isArguments = require_isArguments(),
      isArray = require_isArray(),
      isIndex = require_isIndex(),
      isLength = require_isLength(),
      toKey = require_toKey();
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);
      for (var index2 = -1, length = path.length, result = !1; ++index2 < length;) {
        var key = toKey(path[index2]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
      }
      return result || ++index2 != length ? result : (length = object == null ? 0 : object.length, !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object)));
    }
    module.exports = hasPath;
  }
});
var require_hasIn = __commonJS({
  "../../../node_modules/lodash/hasIn.js"(exports, module) {
    var baseHasIn = require_baseHasIn(),
      hasPath = require_hasPath();
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }
    module.exports = hasIn;
  }
});
var require_basePick = __commonJS({
  "../../../node_modules/lodash/_basePick.js"(exports, module) {
    var basePickBy = require_basePickBy(),
      hasIn = require_hasIn();
    function basePick(object, paths) {
      return basePickBy(object, paths, function (value, path) {
        return hasIn(object, path);
      });
    }
    module.exports = basePick;
  }
});
var require_arrayPush = __commonJS({
  "../../../node_modules/lodash/_arrayPush.js"(exports, module) {
    function arrayPush(array, values) {
      for (var index2 = -1, length = values.length, offset = array.length; ++index2 < length;) array[offset + index2] = values[index2];
      return array;
    }
    module.exports = arrayPush;
  }
});
var require_isFlattenable = __commonJS({
  "../../../node_modules/lodash/_isFlattenable.js"(exports, module) {
    var Symbol = require_Symbol(),
      isArguments = require_isArguments(),
      isArray = require_isArray(),
      spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : void 0;
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
    }
    module.exports = isFlattenable;
  }
});
var require_baseFlatten = __commonJS({
  "../../../node_modules/lodash/_baseFlatten.js"(exports, module) {
    var arrayPush = require_arrayPush(),
      isFlattenable = require_isFlattenable();
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index2 = -1,
        length = array.length;
      for (predicate || (predicate = isFlattenable), result || (result = []); ++index2 < length;) {
        var value = array[index2];
        depth > 0 && predicate(value) ? depth > 1 ? baseFlatten(value, depth - 1, predicate, isStrict, result) : arrayPush(result, value) : isStrict || (result[result.length] = value);
      }
      return result;
    }
    module.exports = baseFlatten;
  }
});
var require_flatten = __commonJS({
  "../../../node_modules/lodash/flatten.js"(exports, module) {
    var baseFlatten = require_baseFlatten();
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }
    module.exports = flatten;
  }
});
var require_apply = __commonJS({
  "../../../node_modules/lodash/_apply.js"(exports, module) {
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    module.exports = apply;
  }
});
var require_overRest = __commonJS({
  "../../../node_modules/lodash/_overRest.js"(exports, module) {
    var apply = require_apply(),
      nativeMax = Math.max;
    function overRest(func, start, transform) {
      return start = nativeMax(start === void 0 ? func.length - 1 : start, 0), function () {
        for (var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array = Array(length); ++index2 < length;) array[index2] = args[start + index2];
        index2 = -1;
        for (var otherArgs = Array(start + 1); ++index2 < start;) otherArgs[index2] = args[index2];
        return otherArgs[start] = transform(array), apply(func, this, otherArgs);
      };
    }
    module.exports = overRest;
  }
});
var require_constant = __commonJS({
  "../../../node_modules/lodash/constant.js"(exports, module) {
    function constant(value) {
      return function () {
        return value;
      };
    }
    module.exports = constant;
  }
});
var require_identity = __commonJS({
  "../../../node_modules/lodash/identity.js"(exports, module) {
    function identity(value) {
      return value;
    }
    module.exports = identity;
  }
});
var require_baseSetToString = __commonJS({
  "../../../node_modules/lodash/_baseSetToString.js"(exports, module) {
    var constant = require_constant(),
      defineProperty = require_defineProperty(),
      identity = require_identity(),
      baseSetToString = defineProperty ? function (func, string) {
        return defineProperty(func, "toString", {
          configurable: !0,
          enumerable: !1,
          value: constant(string),
          writable: !0
        });
      } : identity;
    module.exports = baseSetToString;
  }
});
var require_shortOut = __commonJS({
  "../../../node_modules/lodash/_shortOut.js"(exports, module) {
    var HOT_COUNT = 800,
      HOT_SPAN = 16,
      nativeNow = Date.now;
    function shortOut(func) {
      var count = 0,
        lastCalled = 0;
      return function () {
        var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);
        if (lastCalled = stamp, remaining > 0) {
          if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(void 0, arguments);
      };
    }
    module.exports = shortOut;
  }
});
var require_setToString = __commonJS({
  "../../../node_modules/lodash/_setToString.js"(exports, module) {
    var baseSetToString = require_baseSetToString(),
      shortOut = require_shortOut(),
      setToString = shortOut(baseSetToString);
    module.exports = setToString;
  }
});
var require_flatRest = __commonJS({
  "../../../node_modules/lodash/_flatRest.js"(exports, module) {
    var flatten = require_flatten(),
      overRest = require_overRest(),
      setToString = require_setToString();
    function flatRest(func) {
      return setToString(overRest(func, void 0, flatten), func + "");
    }
    module.exports = flatRest;
  }
});
var require_pick = __commonJS({
  "../../../node_modules/lodash/pick.js"(exports, module) {
    var basePick = require_basePick(),
      flatRest = require_flatRest(),
      pick2 = flatRest(function (object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
    module.exports = pick2;
  }
});
import * as React4 from "react";
import { useRef, useCallback } from "react";
var updateRef = function (ref, value) {
    if (typeof ref == "function") {
      ref(value);
      return;
    }
    ref.current = value;
  },
  useComposedRef = function (libRef, userRef) {
    var prevUserRef = useRef();
    return useCallback(function (instance) {
      libRef.current = instance, prevUserRef.current && updateRef(prevUserRef.current, null), prevUserRef.current = userRef, userRef && updateRef(userRef, instance);
    }, [userRef]);
  },
  use_composed_ref_esm_default = useComposedRef;
var HIDDEN_TEXTAREA_STYLE = {
    "min-height": "0",
    "max-height": "none",
    height: "0",
    visibility: "hidden",
    overflow: "hidden",
    position: "absolute",
    "z-index": "-1000",
    top: "0",
    right: "0"
  },
  forceHiddenStyles = node => {
    Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(key => {
      node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], "important");
    });
  };
var getHeight = (node, sizingData) => {
  let height = node.scrollHeight;
  return sizingData.sizingStyle.boxSizing === "border-box" ? height + sizingData.borderSize : height - sizingData.paddingSize;
};
function calculateNodeHeight(hiddenTextarea, sizingData, value) {
  let minRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  let maxRows = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 999;
  let {
      paddingSize,
      borderSize,
      sizingStyle
    } = sizingData,
    {
      boxSizing
    } = sizingStyle;
  if (hiddenTextarea == null) return [0, 0];
  Object.keys(sizingStyle).forEach(_key => {
    let key = _key;
    hiddenTextarea.style[key] = sizingStyle[key];
  }), forceHiddenStyles(hiddenTextarea), hiddenTextarea.value = value;
  let height = getHeight(hiddenTextarea, sizingData);
  hiddenTextarea.value = "x";
  let rowHeight = Math.max(hiddenTextarea.scrollHeight - paddingSize, 0),
    minHeight = rowHeight * minRows;
  boxSizing === "border-box" && (minHeight = minHeight + paddingSize + borderSize), height = Math.max(minHeight, height);
  let maxHeight = rowHeight * maxRows;
  return boxSizing === "border-box" && (maxHeight = maxHeight + paddingSize + borderSize), height = Math.max(Math.min(maxHeight, height), 0), [height, rowHeight];
}
var import_pick = __toESM(require_pick()),
  SIZING_STYLE = ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "boxSizing", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "lineHeight", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "tabSize", "textIndent", "textRendering", "textTransform", "width", "wordBreak"],
  isIE = typeof document < "u" ? Boolean(document.documentElement.currentStyle) : !1,
  getSizingData = node => {
    let style = window.getComputedStyle(node);
    if (style === null) return null;
    let sizingStyle = (0, import_pick.default)(style, SIZING_STYLE),
      {
        borderBottomWidth,
        borderLeftWidth,
        borderRightWidth,
        borderTopWidth,
        boxSizing,
        paddingBottom,
        paddingLeft,
        paddingRight,
        paddingTop,
        width
      } = sizingStyle;
    if (boxSizing === "") return null;
    if (isIE && boxSizing === "border-box") {
      let widthPxValue = Number.parseFloat(width) + Number.parseFloat(borderRightWidth) + Number.parseFloat(borderLeftWidth) + Number.parseFloat(paddingRight) + Number.parseFloat(paddingLeft);
      sizingStyle.width = "".concat(widthPxValue, "px");
    }
    let paddingSize = Number.parseFloat(paddingBottom) + Number.parseFloat(paddingTop),
      borderSize = Number.parseFloat(borderBottomWidth) + Number.parseFloat(borderTopWidth);
    return {
      sizingStyle,
      paddingSize,
      borderSize
    };
  };
import * as React2 from "react";
import * as React from "react";
import { useLayoutEffect, useEffect } from "react";
var index = typeof document < "u" ? useLayoutEffect : useEffect,
  use_isomorphic_layout_effect_esm_default = index;
var useLatest = function (value) {
  var ref = React.useRef(value);
  return use_isomorphic_layout_effect_esm_default(function () {
    ref.current = value;
  }), ref;
};
var useWindowResizeListener = listener => {
  let latestListener = useLatest(listener);
  React2.useLayoutEffect(() => {
    let handler = event => {
      latestListener.current(event);
    };
    return window.addEventListener("resize", handler), () => {
      window.removeEventListener("resize", handler);
    };
  }, []);
};
import React3 from "react";
var useHiddenTextarea = () => {
  let [hiddenTextarea, setHiddenTextarea] = React3.useState(null);
  return React3.useEffect(() => {
    let textareaElement = document.createElement("textarea");
    return textareaElement.setAttribute("tabindex", "-1"), textareaElement.setAttribute("aria-hidden", "true"), forceHiddenStyles(textareaElement), document.body.append(textareaElement), setHiddenTextarea(textareaElement), () => {
      textareaElement.remove(), setHiddenTextarea(null);
    };
  }, []), hiddenTextarea;
};
var TextareaAutosize = (_a, userRef) => {
  var _b = _a,
    {
      cacheMeasurements,
      maxRows,
      minRows,
      onChange = () => {},
      onHeightChange = () => {}
    } = _b,
    props = __objRest(_b, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);
  let isControlled = props.value !== void 0 && onChange !== void 0,
    ownRef = React4.useRef(null),
    ref = use_composed_ref_esm_default(ownRef, userRef),
    heightRef = React4.useRef(0),
    measurementsCacheRef = React4.useRef(),
    hiddenTextarea = useHiddenTextarea(),
    resizeTextarea = () => {
      let node = ownRef.current,
        nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData(node);
      if (!nodeSizingData) return;
      measurementsCacheRef.current = nodeSizingData;
      let [height, rowHeight] = calculateNodeHeight(hiddenTextarea, nodeSizingData, node.value || node.placeholder || "x", minRows, maxRows);
      heightRef.current !== height && (heightRef.current = height, node.style.setProperty("height", "".concat(height, "px"), "important"), onHeightChange(height, {
        rowHeight
      }));
    },
    handleChange = event => {
      var _a2;
      let didUserResize = ((_a2 = ownRef.current) == null ? void 0 : _a2.style.getPropertyPriority("height")) !== "important";
      !isControlled && !didUserResize && resizeTextarea(), onChange(event);
    };
  return typeof document < "u" && (React4.useLayoutEffect(resizeTextarea), useWindowResizeListener(resizeTextarea)), React4.createElement("textarea", __spreadProps(__spreadValues({}, props), {
    onChange: handleChange,
    ref
  }));
};
TextareaAutosize.displayName = "TexareaAutosize";
var src_default = React4.forwardRef(TextareaAutosize);
export { src_default as default };